export function isTerminalListingGenerationTaskError(error) {
  if (String(error?.code || '').toUpperCase() === 'LISTING_GENERATION_SCOPE_MISMATCH') return true;
  const status = String(error?.data?.status || error?.status || '').trim().toLowerCase();
  if (['failed', 'cancelled', 'canceled', 'scope_mismatch'].includes(status)) return true;
  // A missing server-side task cannot be recovered on refresh. Other HTTP and
  // network failures may be transient, so retain the job/task pair.
  return Number(error?.status) === 404;
}

export function formatListingGenerationError(error, { taskId = '' } = {}) {
  const rawMessage = String(error?.message || error || '').trim();
  const reference = String(taskId || '').trim();
  const internalValidation = rawMessage.match(
    /^(content_planner|title_team|body_team|qa_team|aplus_team)\s+failed validation:\s*(.+)$/i,
  );
  let message = rawMessage;
  if (/\binsufficient[_\s-]?balance\b|余额\s*不足|余额不足|MiniMax API Error\s*\(402\)/i.test(rawMessage)) {
    message = '模型服务余额不足，本轮未生成新的 Listing；请充值或在系统设置中切换可用模型后重试。';
  } else if (/^single-prompt listing brief\b.*(?:failed validation|invalid|contract)/i.test(rawMessage)) {
    message = '商品生成上下文未准备完整，请确认 Step01 商品信息后重新生成。';
  } else if (
    /^single-prompt listing writer\b.*(?:failed validation|returned empty|invalid json|non-object|contract)/i.test(rawMessage)
  ) {
    message = '本轮核心 Listing 未形成可用结果，系统未写入异常内容，请重新生成。';
  } else if (
    /^(?:single-prompt listing reviewer\b|single_prompt_reviewer\b|reviewer revision\b).*(?:failed validation|parse|invalid|contract|unavailable)/i.test(rawMessage)
  ) {
    message = '本轮 Listing 完整审查未正常完成，系统未写入异常审稿结果，请重新生成。';
  } else if (
    /^(?:qa\s*\/\s*a\+ conversion|single-prompt listing qa\s*\/\s*a\+|single_prompt_qa_aplus_conversion)\b.*(?:failed validation|returned empty|invalid json|unsupported output|contract)/i.test(rawMessage)
    || /^single-prompt listing requires at least one complete (?:marketplace q&a row|a\+ module)/i.test(rawMessage)
  ) {
    message = '本轮 Q&A 或 A+ 内容未形成完整结果，系统未写入异常内容，请重新生成。';
  } else if (internalValidation) {
    const [, stage, details] = internalValidation;
    if (stage.toLowerCase() === 'title_team') {
      message = /usedKeywordHints|keyword_(?:coverage|hint)/i.test(details)
        ? '标题关键词使用记录与实际文案不一致，请重新生成标题。'
        : '标题文案未通过长度或本地化质量校验，请检查标题事实与关键词后重试。';
    } else if (stage.toLowerCase() === 'body_team') {
      message = '五点文案未通过事实或关键词质量校验，请检查 Step02 选词与 Fact Team 事实分配后重试。';
    } else if (stage.toLowerCase() === 'qa_team') {
      message = 'Q&A 未通过事实或结构校验，请检查对应五点证据后重试。';
    } else if (stage.toLowerCase() === 'aplus_team') {
      message = 'A+ 内容未通过事实或模块校验，请检查模块证据后重试。';
    } else {
      message = '内容规划未通过事实与关键词分配校验，请重新生成。';
    }
  } else if (!message) {
    message = '本轮未生成新的完整文案，当前内容已保留。';
  }

  const footer = reference
    ? `当前内容已保留。任务参考：${reference}`
    : '当前内容已保留，可调整输入后再次生成。';
  return {
    message,
    reference,
    footer,
  };
}
